import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FilePicker from '../file-picker';
import FieldStatus from '../../../field-status';
import { SIZES } from '../../constants';

const ImagePickerPreview = ({
  imageSource = null,
  size = SIZES.small,
  invalid = false,
  statusText = null,
  disabled = false,
  ...restProps
}) => {
  const imagePreviewClasses = classnames(
    'ws-ui-image-picker-preview',
    `ws-ui-image-picker-preview--${size}`,
    { 'ws-ui-image-picker-preview--disabled': disabled }
  );

  const statusPaddingClass = imageSource && 'ws-ui-image-picker-preview__status-wrapper-padding';
  const appearance = invalid ? 'error' : 'default';

  return (
    <div className={imagePreviewClasses}>
      <div className="ws-ui-image-picker-preview__container">
        {imageSource && (
          <div className="ws-ui-image-picker-preview__preview">
            <img src={imageSource} className="ws-ui-image-picker-preview__image" alt="" />
          </div>
        )}
        <div className="ws-ui-image-picker-preview__picker-wrapper">
          <FilePicker invalid={invalid} size={size} disabled={disabled} {...restProps} />
        </div>
      </div>
      {statusText && (
        <div className={statusPaddingClass}>
          <FieldStatus appearance={appearance} text={statusText} />
        </div>
      )}
    </div>
  );
};

ImagePickerPreview.propTypes = {
  imageSource: PropTypes.string,
  statusText: PropTypes.string,
  invalid: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(SIZES)),
};

export default ImagePickerPreview;
